import React from 'react'
import Grid from '@mui/material/Grid2';
import "./catalogs.css";
import { faAngleRight, faFilePen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import CatalogCategory from '../../../components/catalog/CatalogCategory';
function Catalogs() {
    const roles = localStorage.getItem('role');
    const navigate = useNavigate();
  return (
    <div className='container-fluid px-0'>
        <CatalogCategory/>
        <div className='content_container_articals'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Jobseeker Services</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Catalog <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Jobseeker Services</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="my-4">
                    {/* <Grid size={{md:5,xs:12}} container flexDirection="column">
                        <div className='d-flex jobseekersearch my-3'>
                            <div className='col-2'>
                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                            </div>
                            <div className='col-7'>
                                <input type='text' placeholder='search'
                                    // value={searchQuery}
                                    // onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                            </div>
                            <div className='col-3'>
                                <button 
                                // onClick={handleSearch}
                                >Search</button>
                            </div>
                        </div>
                    </Grid> */}
                    <Grid size={{xs:12}} container className="mt-4 gap-md-4">
                        {roles && roles === "job_seeker" && <>
                        <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Correct My Profile</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small onClick={()=>navigate("/catalogs/editrequest")}>View Details</small>
                        </Grid>
                        <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Report a Technical Issue</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small onClick={()=>navigate("/catalogs/report-tech-issue")}>View Details</small>
                        </Grid>
                        </>}
                        {/* <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Marketing Hold Request</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small>View Details</small>
                        </Grid>
                        <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Report a Technical Issue</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small>View Details</small>
                        </Grid>
                        <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Edit Registration</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small>View Details</small>
                        </Grid>
                        <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Learn about BenchTrack Certifications</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small>View Details</small>
                        </Grid>
                        <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <FontAwesomeIcon className='icons_fa' icon={faFilePen} />
                            <h6>Edit Registration</h6>
                            <span>To start your Jobseeker journey with us, submit the Jobseeker Registration </span>
                            <small>View Details</small>
                        </Grid> */}

                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default Catalogs
